import { useTranslation } from "react-i18next";

import {
  FIRST_SELECTABLE_MINUTE,
  LAST_SELECTABLE_MINUTE,
} from "@lib/store/src/data/timeslots/constants/startAndEndTimes";
import { GanttChart } from "./GanttChart";
import {
  ScheduleMutation,
  ScheduleViewModel,
  validationConfig,
} from "@lib/store/src/ui/hooks/timeslots/useDaySchedule";
import { ValidationMessage } from "./ValidationMessage";

type DayScheduleProps = {
  vm: ScheduleViewModel;
  from?: number;
  to?: number;
  mutation?: ScheduleMutation;

  extraArgs: {
    buildingName?: string;
    workspaceReservationCount?: number;
  };
};

export const DaySchedule = ({
  vm,
  mutation,
  from = FIRST_SELECTABLE_MINUTE,
  to = LAST_SELECTABLE_MINUTE,

  extraArgs,
}: DayScheduleProps) => {
  const { t } = useTranslation();

  // Don't render schedule if key data is still loading
  if (vm.status === "loading") return <h1>Loading...</h1>;

  const validationIssue = vm.schedule.validationIssues.at(0);
  const validation = validationIssue ? validationConfig[validationIssue] : undefined;

  return (
    <>
      {validation && (
        <div className="mb-5">
          <ValidationMessage
            message={t(validation.messageKey, {
              buildingName: extraArgs.buildingName,
              count: extraArgs.workspaceReservationCount,
            })}
            priority={validation.priority}
          />
        </div>
      )}

      <GanttChart
        tracks={vm.schedule.tracks}
        startTime={from}
        endTime={to}
        selectedId={mutation?.entity.id}
        invalidIds={vm.schedule.invalidIds}
      />
    </>
  );
};
